import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import { RouteList } from './routes';

import { AppContainer } from 'components/ui/app-container';
import { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ModalProvider } from 'context/ModalContext/Modal.context';
import { AppContextProvider } from 'context/AppContext';

type AppProps = {
    pca: IPublicClientApplication;
};

const App = ({ pca }: AppProps) => (
    <BrowserRouter>
        <AuthProvider>
            <ModalProvider>
                <AppContextProvider>
                    <AppContainer>
                        <RouteList msalInstance={pca} />
                    </AppContainer>
                </AppContextProvider>
            </ModalProvider>
        </AuthProvider>
    </BrowserRouter>
);

export default App;
